import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3bbf05eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "inner"
}
const _hoisted_2 = { class: "text" }
const _hoisted_3 = ["href"]

import { Skeletor } from 'vue-skeletor';
import { Icon } from '../../Atoms';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoCard',
  props: {
    iconName: {},
    text: {},
    backgroundColor: {},
    borderColor: {},
    lg: { type: Boolean },
    isLoading: { type: Boolean },
    embeddedLink: {},
    embeddedLinkText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["infoCard", { lg: _ctx.lg, loading: _ctx.isLoading }]),
    style: _normalizeStyle({
      backgroundColor: _ctx.isLoading ? 'transparent' : _ctx.backgroundColor,
      borderColor: _ctx.borderColor ? _ctx.borderColor : 'transparent',
    })
  }, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.iconName)
            ? (_openBlock(), _createBlock(_unref(Icon), {
                key: 0,
                "icon-name": _ctx.iconName
              }, null, 8, ["icon-name"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
            (_ctx.embeddedLink && _ctx.embeddedLinkText)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "embeddedLink",
                  href: _ctx.embeddedLink,
                  target: "_blank"
                }, _toDisplayString(_ctx.embeddedLinkText), 9, _hoisted_3))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 1 }))
        : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})